<template>
	<v-main>
		<v-container fluid class="pa-0">
			<v-fade-transition mode="out-in">
				<router-view />
			</v-fade-transition>
		</v-container>
	</v-main>
</template>
<script>
export default { metaInfo() { return { title: 'Séculos Sistemas' } },}
</script>
